import React, { useState } from 'react';

import { FaCartArrowDown, FaShare } from 'react-icons/fa';
import { BsFillLightningChargeFill } from 'react-icons/bs';
import FlightsClock from '../../../shared/components/FlightsClock';
import GeoclientTourButton from '../components/Geoclient/GeoclientTourButton';
import formatNumber from '../utils/formatNumber';
import { Link } from 'react-router-dom';
import { CURRENCY_MAP_ICON } from '../constants/CurrencyClasses';
import {
  AiOutlineCalendar,
  AiOutlineClose,
  AiOutlineCoffee,
} from 'react-icons/ai';
import { IoAirplaneOutline, IoBedOutline } from 'react-icons/io5';
import moment from 'moment';

const OneTour = ({
  row,
  tour,
  hideoperator = false,
  geoclient,
  row_fix,
  onAction,
  setTourToShare,
  setOpenModal,
}) => {
  const row_valid = {
    provider: row_fix.row.provider,
    request_id: row_fix.row.request_id,
    source_id: row_fix.row.source_id,
    hash: row_fix.row.hash,
    currency_class: row_fix.row.currency_class,
    base_tour: 0,
    depart_id: row_fix.row.depart_id,
    depart_name: row_fix.row.depart_name,
    hotel_id: row_fix.row.hotel_id,
    hotel_name: row_fix.row.hotel_name,
    star_id: row_fix.row.star_id,
    hotelrating: row_fix.row.hotelrating,
    hoteldescription: row_fix.row.hoteldescription,
    hotel_image_src: row_fix.row.hotel_image_src,
    hotel_link: row_fix.row.hotel_link,
    reviewlink: row_fix.row.reviewlink,
    country_id: row_fix.row.country_id,
    country_name: row_fix.row.country_name,
    town_id: row_fix.row.town_id,
    town_name: row_fix.row.town_name,
    subregion_id: row_fix.row.subregion_id,
    subregionname: row_fix.row.subregionname,
    isphoto: row_fix.row.isphoto,
    isdescription: row_fix.row.isdescription,
    isreviews: row_fix.row.isreviews,
    iscoords: row_fix.row.iscoords,
    seadistance: row_fix.row.seadistance,
    currency: row_fix.row.currency,
    priceue: tour.priceue,
    offer_id: tour.tourid,
    place_id: tour.placement,
    place_name: tour.placement,
    room_id: tour.room,
    room_name: tour.room,
    oper_id: tour.operatorcode,
    oper_name: tour.operatorname,
    child: row_fix.row.child,
    ages: row_fix.row.ages,
    meal_full: tour.mealrussian,
    meal_id: tour.mealcode,
    meal_name: tour.meal,
    star_name: row_fix.row.starname,
    dt1: tour.flydate,
    nights: tour.nights,
    dt2: tour.flydate,
    volatility: row_fix.row.volatility,
    text: row_fix.row.text,
    discount: false,
    comment: '',
    full_price: tour.price,
    price: tour.price,
    claim_mark: 'agency',
    credit: false,
    promo: 0,
    hotel_adult: tour.adults,
    hotel_child: tour.child,
    adult: row_fix.row.adult,
  };

  const [isTourCardHidden, setTourCardHidden] = useState(false);

  const touroperatorLogoUrl = `https://geograftour.com/static/index/img/touroperator/tourvisor/`;
  const tourBaseUrl = 'https://www.geograftour.com/tours/agency-tour-info/';

  function hideTourCard() {
    setTourCardHidden(!isTourCardHidden);
  }

  return (
    <article
      className={`agency-mini-tour${
        isTourCardHidden ? ' agency-mini-tour_hidden' : ''
      }`}
    >
      <AiOutlineClose
        title="Скрыть данный отель"
        className="agency-mini-tour__close-btn"
        onClick={hideTourCard}
      />
      <div className="tour__operator-name price__operator-name">
        <div className="tour__flight">
          <div className="tour__info-block tour__dates-info">
            <div className="tour__info tour__info-dates">
              <span className="tour__info-dates-period">
                <AiOutlineCalendar className="tour__icon" />
                {moment(tour.flydate, 'DD.MM.YYYY').format('DD MMM')}
                {' — '}
                {moment(tour.flydate, 'DD.MM.YYYY')
                  .add('day', +tour.nights)
                  .format('DD MMM')}
              </span>
              <span className="tour__info-dates-nights">
                {` (${tour.nights} ночей)`}
                <FlightsClock tour_id={tour.tourid} />
              </span>
            </div>
            <GeoclientTourButton
              tour={row_valid}
              geoclient={geoclient}
              onAction={onAction}
            />
          </div>
          <div className="tour__info-block tour__info-hotel">
            <div className="tour__info tour__meal-info">
              <AiOutlineCoffee className="tour__icon" />
              {`${tour.meal} - ${tour.mealrussian}`}
            </div>
            <div className="tour__info tour__room-info">
              <IoBedOutline className="tour__icon" />
              {`${tour.placement} | ${tour.room}`}
            </div>
            <div className="tour__info tour__flight-info">
              <IoAirplaneOutline className="tour__icon" />
              <span>
                {tour.tourname},
                {+row_valid.depart_id === 99 ? (
                  ' Без перелета'
                ) : (
                  <>
                    {tour.regular === 1
                      ? ' Рейс регулярный, возможны доплаты'
                      : ' Чартер'}
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="tour__actions">
        {!hideoperator ? (
          <img
            src={`${touroperatorLogoUrl}${tour.operatorcode}.png`}
            alt={row.tours.tour[0].operatorname}
            className="tour__operator-logo"
            loading="lazy"
          />
        ) : (
          <div></div>
        )}
        <div className="tour__cabinet-btns">
          <FaShare
            title="Поделиться туром"
            className="tour__cabinet-button"
            onClick={(e) => {
              e.preventDefault();
              setOpenModal(true);
              setTourToShare(row_valid);
            }}
          />
          <Link
            to={`${tourBaseUrl}${row_valid.offer_id}/?currency=${row_valid.currency}`}
            className="tour__link"
            target="_blank"
          >
            {tour.hotelstatus === 2 && (
              <span className="permanent-booking-container">
                <BsFillLightningChargeFill
                  className="permanent-booking-icon"
                  title="Мгновенное бронирование"
                />
              </span>
            )}
            <FaCartArrowDown className="tour__link-icon" />
            <span className="tour__link-price">
              {formatNumber(tour.price)}{' '}
              <small>{CURRENCY_MAP_ICON[tour.currency]}</small>
            </span>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default OneTour;
